// @flow
/* ***************************************************************************
* @author Afonso Bordado (abordado@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import { debtSimpleSearch, submitToCitius } from "../../actions"
import { connect } from "react-redux"
import DebtList from "../../components/DebtList"
import * as strings from "../../strings"
import { handlePickedBoxes } from "../../utils"
import Dropdown from "react-toolbox/lib/dropdown"
import Input from "react-toolbox/lib/input"
import { Button } from "react-toolbox/lib/button"
import styles from "./style.css"
import _ from "lodash"

export const CONFIG_ITEM_MAP = {
  // TODO: Check if these two are correct
  id: "idDebt",
  processId: "plid",

  name: "name",
  nif: "nif",
  procedurePhase: "debtPhase",

  injunctionId: "injunctionNumber",

  debtValue: "debtValue",
  clientName: "clientName",

  // "preLitigationSubType",
  // "preLitigationType",

  // "litigationSubType",
  // "litigationType",

  // "executionNumber",

  court: "executionService",
}
const ITEMS_PER_PAGE = 10
const FIRST_PAGE = 1
const INITIAL_PAGINATION = {
  limit: ITEMS_PER_PAGE,
  offset: 0,
}

// TODO: Enable the infinite scroll
class SimpleSearch extends Component {
  props: {
    auth: any,
    user: any,
    debtSimpleSearch: any,
    match: {
      params: {
        term: string,
      }
    }
  }

  state = {
    searchResults: undefined,
    searchTerm: undefined,
    pagination: INITIAL_PAGINATION,
    pickedDebts: [],
    itemsPerPage: ITEMS_PER_PAGE,
    activePage: FIRST_PAGE,
    totalItems: undefined,
    showCustomPagination: false,
    customNumberOfItems: ITEMS_PER_PAGE,
    customizedNumber: undefined,
    loading: true,
    differentPagination: [
      { value: 10, label: "10" },
      { value: 50, label: "50" },
      { value: 100, label: "100" },
      { value: "personalizar", label: strings.generalStrings.customize },
    ],
  }

  fetchResults = ( term, pagination, isNewTerm, activePage ) => {
    this.setState( {
      loading: true,
    } )
    // TODO: Better error handling on failed request
    const decodedTerm = decodeURIComponent( term || "" )
    debtSimpleSearch( this.props.auth.token, decodedTerm, pagination )
      .then( response => {
        if ( response.message !== "OK" ) {
          return null
        }
        return response.result
      } )
      .then( searchResults => {
        this.setState( {
          searchResults,
          searchTerm: term,
          totalItems: searchResults.count,
          pagination,
          pickedDebts: [],
          activePage: activePage || this.state.activePage,
          loading: false,
        } )
      } )
  }

  handleDifferentPagination = ( itemsPerPage ) => {
    if ( _.isEqual( itemsPerPage, "personalizar" ) ) {
      this.setState( {
        showCustomPagination: true,
        customNumberOfItems: itemsPerPage,
      } )
    } else {
      const newPagination = {
        limit: itemsPerPage,
        offset: 0,
      }
      this.fetchResults( this.state.searchTerm, newPagination, false, 1 )
      this.setState( {
        showCustomPagination: false,
        customNumberOfItems: itemsPerPage,
        customizedNumber: undefined,
      } )
    }
  }

  handleCustomPagination = () => {
    const newPagination = {
      limit: _.isEqual( this.state.customizedNumber, "" ) ? this.state.pagination.limit : this.state.customizedNumber,
      offset: 0,
    }
    this.fetchResults( this.state.searchTerm, newPagination, false, 1 )
  }

  handlePageChange = ( pageNumber ) => {
    const { pagination } = this.state
    const newPagination = {
      limit: pagination.limit,
      offset: ( pagination.limit * pageNumber ) - pagination.limit,
    }
    this.fetchResults( this.state.searchTerm, newPagination, false, pageNumber )
  }

  handleNewTerms = ( oldTerm, newTerm ) => {
    if ( newTerm !== oldTerm || !this.state.searchResults ) {
      const isNewTerm = true
      this.fetchResults( newTerm, INITIAL_PAGINATION, isNewTerm, 1 )
    }
  }

  componentWillMount = () => {
    const currentTerm = this.props.match.params.term
    const searchTerm = this.state.searchTerm
    this.handleNewTerms( searchTerm, currentTerm )
  }

  // This may seem duplicated logic, but it isn't, this function handles different searches
  // on the same page, the componentWillMount handles when first mounting
  componentWillReceiveProps = nextProps => {
    const newTerm = nextProps.match.params.term
    const currentTerm = this.props.match.params.term
    this.handleNewTerms( currentTerm, newTerm )
  }

  pickAllProcesses = () => {
    const decodedTerm = decodeURIComponent( this.state.searchTerm || "" )
    debtSimpleSearch( this.props.auth.token, decodedTerm,
      { limit: this.state.totalItems, offset: 0 }, { ids: true } )
      .then( response => {
        if ( response.message !== "OK" ) {
          return null
        }
        return response.result
      } )
      .then( searchResults => {
        const pickedDebts = _.isEqual( this.state.pickedDebts.length, searchResults.data.length ) ? [] : searchResults.data
        this.setState( {
          pickedDebts,
        } )
      } )
  }

  pickedBoxesHandler = ( element ) => () => {
    return this.setState( {
      pickedDebts: handlePickedBoxes( element, this.state.pickedDebts, this.state.searchResults ),
    } )
  }

  renderLoadingDialog = () => {
    return (
      <div className={styles.loadingWrapper}>
        <div className={styles.loader}>
        </div>
      </div>
    )
  }

  render () {
    const searchResults = this.state.searchResults
    if ( searchResults === undefined ) { // TODO: Loading animation
      return this.renderLoadingDialog()
    }

    if ( searchResults === null ) { // TODO: Proper error message
      return (
        <div>
          {strings.errorMessages.anErrorHasOccurred}
        </div>
      )
    }
    return (
      <div style={{ height: "100%", display: "flex", "flex-direction": "column" }}>
        <div className={styles.topButtonsContainer}>
          <Button label={strings.generalStrings.pickAllProcesses}
            onClick={this.pickAllProcesses} raised primary />
          <Dropdown
            auto
            label={strings.generalStrings.itemsPerPage}
            onChange={this.handleDifferentPagination}
            source={this.state.differentPagination}
            value={this.state.customNumberOfItems}
          />
          {this.state.showCustomPagination ?
            <div>
              <Input type="number" label={strings.generalStrings.numberOfItemsPerPage}
                name="name" value={this.state.customizedNumber}
                onChange={ ( customNumberOfItems ) => this.setState( {
                  customizedNumber: _.isEqual( customNumberOfItems, "" ) ? customNumberOfItems : parseFloat( customNumberOfItems ),
                } )}
                onBlur={this.handleCustomPagination} />
            </div> : <div/>}
        </div>
        <DebtList
          items={searchResults || []}
          userConfig={this.props.user.config}
          configItemMap={CONFIG_ITEM_MAP}
          itemsPerPage={this.state.pagination.limit}
          activePage={this.state.activePage}
          totalItems={this.state.totalItems}
          handlePageChange={this.handlePageChange}
          onChange={this.pickedBoxesHandler}
          pickedDebts={this.state.pickedDebts}
          loading={this.state.loading}
          submitToCitius={ids => submitToCitius( this.props.auth.token, ids )}
        />
      </div>
    )
  }
}

const mapStateToProps = ( store ) => {
  return {
    auth: store.auth,
    user: store.user,
  }
}

export default connect( mapStateToProps )( SimpleSearch )



// WEBPACK FOOTER //
// ./src/views/SimpleSearch/index.jsx